export const useImageDimensions = async (
  blob: Blob
): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const imageUrl = URL.createObjectURL(blob);
    const img = new Image();
    img.onload = () => {
      // Get dimensions and clean up URL
      const dimensions = { width: img.width, height: img.height };
      URL.revokeObjectURL(imageUrl);
      resolve(dimensions);
    };
    img.onerror = () => {
      URL.revokeObjectURL(imageUrl);
      reject(new Error("Failed to load image"));
    };
    img.src = imageUrl;
  });
};
